// TODO-MOBILE Might need to use ionic for this?
// Persistence
import localStorageService from '../../utils/services/localStorage/localStorage';

export const BOARD_PAGE_APPEARANCE_LOCAL_STORAGE_KEY = 'milanote.mobile.boardPageAppearance';

export const getMobileBoardPageAppearanceLocalStorage = () =>
    localStorageService.getItem(BOARD_PAGE_APPEARANCE_LOCAL_STORAGE_KEY);
export const setMobileBoardPageAppearanceLocalStorage = (value: string) =>
    localStorageService.setItem(BOARD_PAGE_APPEARANCE_LOCAL_STORAGE_KEY, value);
